import { Flex } from 'foundations-components/components/Flex';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { usePortalNavigation } from '../hooks/usePortalNavigation';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LOGOUT_URL = '/_hcms/mem/logout';
export function PortalsAccessDenied() {
  const {
    requestedInstanceDisplayName
  } = usePortalNavigation();
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    minBlockSize: "100%",
    padding: "800",
    gap: "400",
    children: [/*#__PURE__*/_jsx(H2, {
      color: "text-core-default",
      textAlign: "center",
      children: requestedInstanceDisplayName ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.accessDenied.headingWithName",
        options: {
          portalName: requestedInstanceDisplayName
        }
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.accessDenied.heading"
      })
    }), /*#__PURE__*/_jsx(Paragraph, {
      color: "text-core-subtle",
      textAlign: "center",
      marginBlock: "0",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.accessDenied.body"
      })
    }), /*#__PURE__*/_jsx(Button, {
      use: "primary",
      href: LOGOUT_URL,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.accessDenied.logout"
      })
    })]
  });
}